{
	"after_call": "Dopo il bando",
	"category": {
		"doctoral_and_specialization": "Dottorato e specializzazione",
		"first_year": "Primo anno",
		"later_years": "Anni successivi",
		"unknown": "Da definire"
	},
	"columns": {
		"category": "Categoria",
		"criterion": "Criterio",
		"effective": "Fa fede dal",
		"flags": "Segnalazioni",
		"name": "Cognome e nome",
		"origin": "Origine",
		"protocol": "Prot.",
		"quotas": "Quote",
		"state": "Stato"
	},
	"correction": {
		"after": "Dopo",
		"back": "Torna ai campi",
		"before": "Prima",
		"description": "Cambia solo i campi trascritti male. Ogni modifica resta nello storico con il valore di prima, e i requisiti si rivalutano con i dati nuovi.",
		"field": "Campo",
		"no_changes": "Nessun campo è cambiato.",
		"not_allowed_description": "Si correggono solo le domande arrivate via PEC diretta e ancora valide.",
		"not_allowed_title": "Questa domanda non si può correggere",
		"page_title": "Correggi trascrizione",
		"review": "Rivedi le modifiche",
		"review_title": "Modifiche da salvare",
		"save": "Salva la correzione",
		"saved": "Correzione salvata",
		"tax_code_locked": "Il codice fiscale non si corregge: un codice diverso è un'altra persona, quindi un'altra domanda da caricare."
	},
	"criterion": {
		"credits": "{{value}} CFU",
		"iseeu": "ISEEU {{value}}"
	},
	"detail": {
		"breadcrumb": "Domanda",
		"changed": {
			"refresh": "Aggiorna",
			"submitted": "La domanda è cambiata dopo che hai aperto questa pagina: i dati qui sotto sono quelli di prima.",
			"superseded": "La domanda è stata sostituita da una più recente dopo che hai aperto questa pagina: i dati qui sotto sono quelli di prima.",
			"withdrawn": "La domanda è stata ritirata dopo che hai aperto questa pagina: i dati qui sotto sono quelli di prima."
		},
		"course_type": {
			"bachelor": "Laurea triennale",
			"master": "Laurea magistrale",
			"phd": "Dottorato di ricerca",
			"single_cycle": "Laurea magistrale a ciclo unico",
			"specialization": "Scuola di specializzazione"
		},
		"declaration_made": "Resa il {{date}}",
		"declaration_missing": "Non ancora resa",
		"declarations_made": "Rese alla firma, il {{date}}",
		"direct": {
			"arrived_at": "Arrivata il",
			"by_at": "{{name}}, {{when}}",
			"correct": "Correggi trascrizione",
			"corrections": "Correzioni di trascrizione",
			"email_reply": "Email di conferma inviata in automatico",
			"message": "Messaggio originale",
			"message_kind": {
				"eml": "File .eml",
				"pdf": "PDF"
			},
			"pec_reply": "Risposta al mittente",
			"pec_reply_pending": "Da inviare dalla PEC della residenza",
			"pec_reply_sent": "Inviata dalla PEC il {{when}}",
			"section": "Ricevuta via PEC diretta",
			"sender": "Mittente",
			"unknown_author": "Account rimosso",
			"uploaded": "Caricata da"
		},
		"fields": {
			"birth_date": "Data di nascita",
			"birth_place": "Luogo di nascita",
			"campus": "Sede dei corsi",
			"campus_address": "Indirizzo della sede didattica",
			"category": "Categoria",
			"course_name": "Nome del corso",
			"course_type": "Tipo di corso",
			"credits": "Crediti conseguiti",
			"effective": "Fa fede dal",
			"email": "Email della domanda",
			"enrollment_year": "Anno di iscrizione",
			"exclude_q70": "Esclusione dalla quota 70%",
			"first_name": "Nome",
			"grade_average": "Media dei voti",
			"institution": "Ateneo",
			"iseeu": "ISEEU",
			"ispeu": "ISPEU",
			"last_name": "Cognome",
			"needs_equipped": "Alloggio attrezzato",
			"no": "No",
			"none": "Nessuno",
			"not_given": "Non indicato",
			"passport": "Passaporto",
			"phone": "Telefono",
			"pre_enrollment_number": "Numero di preimmatricolazione",
			"protocol": "Protocollo",
			"quotas": "Quote",
			"residence": "Residenza",
			"room_preference": "Preferenza di camera",
			"student_number": "Numero di matricola",
			"tax_code": "Codice fiscale",
			"warnings": "Requisiti non soddisfatti",
			"yes": "Sì"
		},
		"not_found": "Domanda non trovata",
		"room": {
			"double": "Camera doppia",
			"none": "Nessuna preferenza",
			"single": "Camera singola"
		},
		"sections": {
			"declarations": "Dichiarazioni",
			"economic": "Situazione economica",
			"enrollment": "Iscrizione",
			"files": "File inviati",
			"flags": "Segnalazioni sui requisiti",
			"history": "Storico",
			"preferences": "Preferenze e requisiti",
			"student": "Dati del richiedente"
		},
		"superseded_note": "Sostituita dalla domanda prot. {{protocol}}",
		"title": "Domanda prot. {{protocol}}",
		"warning": {
			"cfu_below_min": "Crediti sotto il minimo del bando",
			"iseeu_above": "ISEEU sopra la soglia del bando",
			"ispeu_above": "ISPEU sopra la soglia del bando",
			"offsite_not_met": "Requisito di fuori sede non soddisfatto"
		},
		"withdrawn_elsewhere_note": "Ritirata il {{date}}: ha accettato un posto in un'altra struttura",
		"withdrawn_note": "Ritirata il {{date}}"
	},
	"disability_priority": {
		"cause": "Documentazione della disabilità mancante o non valida",
		"cause_label": "Causa:",
		"confirm": "Togli la priorità",
		"dialog_description": "La domanda torna nella sua posizione normale. Se quella posizione le dà lo stesso posto, l'offerta resta, anche se già accettata; altrimenti il posto passa al prossimo studente in graduatoria. Lo studente riceve un'email con la causa.",
		"dialog_title": "Togliere la priorità per disabilità?",
		"done": "Priorità tolta: la graduatoria si ricalcola a breve.",
		"held": "La domanda ha avuto un posto attrezzato con la priorità per disabilità. Controlla il documento della disabilità tra i file: se manca o non è valido, togli la priorità.",
		"note": "Nota per lo studente (facoltativa)",
		"restore": "Ridai la priorità per disabilità",
		"restore_confirm": "Ridai la priorità",
		"restore_description": "La graduatoria si ricalcola con la priorità. Un posto già offerto a un altro studente non torna indietro: la domanda ha il posto con la priorità solo se ce n'è ancora uno libero.",
		"restore_reason": "Motivo",
		"restore_reason_hint": "Per esempio: tolta per errore, o il documento è valido. Resta nel registro.",
		"restore_title": "Ridare la priorità per disabilità?",
		"restored": "Priorità ridata: la graduatoria si ricalcola a breve.",
		"revoke": "Togli la priorità per disabilità",
		"revoked": "La priorità per disabilità è stata tolta: la domanda resta in graduatoria nella sua posizione normale. Se è stato un errore, o il documento si è rivelato valido, ridai la priorità.",
		"title": "Priorità per disabilità"
	},
	"empty": "Nessuna domanda ricevuta",
	"empty_filtered": "Nessuna domanda con questi filtri",
	"files": {
		"document": {
			"credits_screenshot": "Schermata degli esami",
			"disability": "Documento della disabilità",
			"doctoral_enrollment": "Iscrizione al dottorato o alla specializzazione",
			"enrollment": "Documento di ateneo",
			"identity": "Documento di identità",
			"iseeu_ispeu": "Attestazione ISEEU e ISPEU"
		},
		"download": "Scarica",
		"empty": "Nessun file.",
		"failed": "Non siamo riusciti a scaricare il file. Riprova.",
		"kind": {
			"annex_a": "Allegato A",
			"direct_message": "Messaggio arrivato alla PEC",
			"document": "Documento"
		},
		"platform_only": "Solo sulla piattaforma: non inviato alla PEC del bando",
		"sha256": "SHA-256 {{value}}"
	},
	"filters": {
		"category": "Categoria",
		"flags": "Segnalazioni",
		"origin": "Origine",
		"quota": "Quota",
		"review": "Validità",
		"sent": "Invio",
		"state": "Stato",
		"with_open_flags": "Con segnalazioni aperte"
	},
	"intake": {
		"annex_email_hint": "L'email scritta nell'Allegato A.",
		"back": "Indietro",
		"birth_country": "Stato di nascita",
		"born_abroad": "Nato all'estero",
		"choose": "Scegli",
		"close": {
			"cancel": "Annulla",
			"command": "Ho caricato tutte le domande ricevute via PEC",
			"confirm": "Chiudi il caricamento",
			"description_one": "Hai caricato {{count}} domanda ricevuta via PEC. Dopo la chiusura non se ne possono caricare altre.",
			"description_other": "Hai caricato {{count}} domande ricevute via PEC. Dopo la chiusura non se ne possono caricare altre.",
			"done": "Caricamento chiuso",
			"title": "Chiudi il caricamento"
		},
		"closed_description": "Si possono caricare domande dall'apertura del bando fino alla chiusura del caricamento.",
		"closed_title": "Il caricamento delle domande arrivate via PEC è chiuso",
		"command": "Carica domanda ricevuta via PEC",
		"country_empty": "Nessuno Stato trovato.",
		"country_placeholder": "Cerca lo Stato",
		"credits_hint": "Lascia vuoto se l'Allegato A non li indica.",
		"declarations": {
			"noConvictions": "Nessuna condanna né carichi pendenti",
			"noDebts": "Nessuna posizione debitoria verso il gestore",
			"noIncompatibleIllness": "Nessuna patologia incompatibile con la vita di comunità",
			"offSite": "Dichiarazione di essere fuori sede"
		},
		"description": "Carica una domanda arrivata alla PEC della struttura: messaggio originale, trascrizione dell'Allegato A, controllo delle altre domande della stessa persona e riepilogo.",
		"documents": {
			"hint": "Carica i documenti allegati al messaggio e indica cosa sono.",
			"kind": "Tipo di documento",
			"remove": "Togli il documento",
			"too_large": "Il file supera 10 MB.",
			"upload_failed": "Non siamo riusciti a caricare il documento. Riprova.",
			"wrong_type": "Il file non è un PDF, un JPG o un PNG."
		},
		"duplicates": {
			"failed": "Non siamo riusciti a leggere le altre domande. Riprova.",
			"none": "Nessun'altra domanda con questo codice fiscale in questa struttura.",
			"other_counts": "Varrà la domanda prot. {{protocol}}: è stata inviata dopo questa.",
			"protocol": "Prot. {{protocol}}",
			"rule": "Tra due domande della stessa persona nella stessa struttura vale quella inviata per ultima prima della chiusura del bando.",
			"this_counts": "Varrà questa domanda: è stata inviata dopo la domanda prot. {{protocol}}."
		},
		"errors": {
			"direct_arrival_not_certified": "La PEC certifica l'arrivo il {{date}} alle {{time}}: è l'orario che conta, e lo abbiamo scritto al posto del tuo.",
			"direct_arrived_after_close": "La PEC è arrivata dopo la chiusura del bando e non si può caricare.",
			"direct_arrived_out_of_window": "L'arrivo è nel futuro o prima dell'apertura del bando.",
			"direct_tax_code_invalid": "Codice fiscale non valido o non coerente con nome, cognome e data di nascita."
		},
		"extra_semester": "Semestre aggiuntivo",
		"family_abroad": "Nucleo familiare all'estero",
		"field_errors": {
			"arrivalDate": "Scrivi la data di arrivo della PEC.",
			"arrivalTime": "Scrivi l'ora di arrivo, ora italiana.",
			"birthCountryCode": "Scegli lo Stato di nascita.",
			"birthDate": "Scrivi la data di nascita.",
			"birthMunicipalityIstatCode": "Scegli il comune di nascita dall'elenco.",
			"campusAddress": "Scrivi via e numero civico della sede didattica.",
			"campusCode": "Scegli la sede dei corsi.",
			"courseName": "Scrivi il nome del corso.",
			"courseType": "Scegli il tipo di corso.",
			"credits": "Scrivi i crediti come numero intero, oppure lascia vuoto.",
			"default": "Controlla questo campo.",
			"email": "Scrivi un indirizzo email valido, come nome@esempio.it.",
			"enrollmentYear": "Scegli l'anno di iscrizione.",
			"firstName": "Scrivi il nome come nell'Allegato A.",
			"gradeAverage": "Scrivi la media da 18 a 30, con al massimo due decimali, oppure lascia vuoto.",
			"institutionCode": "Scegli l'ateneo.",
			"iseeuCents": "Scrivi l'ISEEU in euro.",
			"ispeuCents": "Scrivi l'ISPEU in euro.",
			"lastName": "Scrivi il cognome come nell'Allegato A.",
			"messageAssetId": "Carica il messaggio originale.",
			"phone": "Scrivi un numero di telefono valido.",
			"residenceAddress": "Scrivi l'indirizzo di residenza.",
			"residenceCountryCode": "Scegli lo Stato di residenza.",
			"residenceMunicipalityIstatCode": "Scegli il comune di residenza dall'elenco.",
			"residencePostalCode": "Il CAP ha 5 cifre.",
			"senderAddress": "Scrivi l'indirizzo del mittente.",
			"taxCode": "Il codice fiscale ha 16 caratteri, lettere e cifre."
		},
		"fix_fields": "Controlla i campi evidenziati.",
		"grade_average_hint": "Lascia vuoto se l'Allegato A non la indica.",
		"groups": {
			"declarations": "Dichiarazioni",
			"documents": "Documenti ricevuti",
			"economic": "Requisiti economici",
			"enrollment": "Iscrizione",
			"person": "Dati personali",
			"preferences": "Preferenze",
			"residence": "Residenza"
		},
		"invalid": "Valore non valido.",
		"invalid_email": "Indirizzo email non valido.",
		"leave": {
			"description": "I dati inseriti non sono salvati e andranno persi.",
			"leave": "Esci",
			"stay": "Resta",
			"title": "Uscire senza registrare?"
		},
		"message": {
			"arrival_date": "Data di arrivo",
			"arrival_time": "Ora di arrivo",
			"file": "Messaggio originale",
			"file_hint": "Il messaggio come è arrivato: il file .eml salvato dalla casella PEC, oppure il PDF.",
			"italian_time": "Ora italiana.",
			"kind": {
				"email": "Mittente email ordinaria",
				"pec": "Mittente PEC"
			},
			"missing": "Carica il messaggio originale.",
			"not_read": "Dal messaggio non si leggono arrivo e mittente: inseriscili tu.",
			"proposed": "Arrivo e mittente sono letti dal messaggio: controllali.",
			"reading": "Lettura del messaggio",
			"sender": "Indirizzo del mittente",
			"sender_hint": "Qui andrà l'eventuale offerta.",
			"sender_kind": "Tipo di mittente",
			"too_large": "Il file supera 25 MB.",
			"upload_failed": "Non siamo riusciti a caricare il file. Riprova.",
			"uploading": "Caricamento in corso",
			"wrong_type": "Il file non è un .eml né un PDF."
		},
		"municipality_empty": "Nessun comune trovato.",
		"municipality_hint": "Scrivi almeno due lettere del nome del comune.",
		"municipality_placeholder": "Cerca il comune",
		"next": "Avanti",
		"page_title": "Carica domanda ricevuta via PEC",
		"passport_number": "Numero di passaporto",
		"passport_number_hint": "Solo se il nucleo familiare vive all'estero e lo studente non ha il codice fiscale.",
		"passport_of": "passaporto {{number}}",
		"places_required": "Indica il comune o lo Stato di nascita e di residenza.",
		"postal_code": "CAP",
		"register": "Registra domanda",
		"registered": {
			"back": "Torna alle domande",
			"born_superseded": "Non vale: la domanda prot. {{protocol}} della stessa persona è stata inviata dopo.",
			"copied": "Testo copiato.",
			"copy": "Copia testo",
			"counts": "La domanda è valida.",
			"email_sent": "Lo studente riceve un'email con i dati trascritti.",
			"open": "Apri la domanda",
			"replaces": "Sostituisce la domanda prot. {{protocol}}, inviata prima.",
			"reply_hint": "Il mittente ha scritto da una PEC: invia questo testo dalla PEC della struttura, poi segna la risposta come inviata.",
			"reply_marked": "Risposta registrata come inviata.",
			"reply_sent": "Ho inviato la risposta",
			"reply_title": "Testo da inviare dalla PEC della struttura",
			"title": "Domanda registrata con il protocollo {{protocol}}"
		},
		"required": "Campo obbligatorio.",
		"residence_address": "Indirizzo di residenza",
		"residence_country": "Stato di residenza",
		"status": {
			"declared": "Caricamento chiuso da {{name}}: {{date}}.",
			"expired": "Chiuso per scadenza del termine: {{date}}.",
			"open_call": "Puoi caricare le domande arrivate alla PEC della struttura fino alla chiusura del caricamento.",
			"open_until": "Caricamento aperto. Scadenza: {{date}} alle 24:00.",
			"someone": "un gestore"
		},
		"steps": {
			"duplicates": "Altre domande della persona",
			"message": "Messaggio originale",
			"summary": "Riepilogo",
			"transcription": "Trascrizione"
		},
		"summary": {
			"arrival": "Arrivo della PEC",
			"message": "Messaggio originale",
			"no_preview": "Il messaggio non si può mostrare qui.",
			"reviewed": "Ho ricontrollato i dati trascritti",
			"reviewed_required": "Conferma di aver ricontrollato i dati."
		},
		"tax_code_hint": "Il codice fiscale non si corregge dopo la registrazione: controllalo bene."
	},
	"notice": {
		"replacement": "Sostituita: da vedere",
		"restored": "Di nuovo valida: da vedere",
		"withdrawal": "Ritirata: da vedere"
	},
	"origin": {
		"direct_pec": "Ricevuta via PEC diretta",
		"platform": "Piattaforma"
	},
	"page_title": "Domande",
	"quota": {
		"none": "Nessuna quota",
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"review": {
		"acknowledge": "Conferma la validità",
		"acknowledged_at": "Validità confermata il {{when}}",
		"acknowledged_done": "Validità confermata. Lo studente riceve un'email.",
		"already_reviewed": "La validità di questa domanda è già confermata: la pagina è aggiornata.",
		"cause": {
			"annex_mismatch": "L'Allegato A è diverso da quello generato (o il codice di controllo non corrisponde)",
			"annex_unreadable": "L'Allegato A è illeggibile o incompleto",
			"identity_document_problem": "Il documento d'identità manca o è illeggibile",
			"missing_signature": "L'Allegato A non è firmato"
		},
		"check_code": "Codice di controllo",
		"dialog_description": "Scegli cosa non va. Lo studente riceve un'email con la causa e può correggere e inviare di nuovo la domanda fino alla chiusura del bando; la domanda resta in graduatoria.",
		"dialog_title": "Segnala un problema nella domanda",
		"help": "Cerca nella PEC l'email con questo oggetto, confronta il codice di controllo con quello dell'Allegato A e leggi i dati. Quando confermi la validità lo studente riceve un'email. La graduatoria si approva solo quando ogni domanda è confermata o ha un problema segnalato.",
		"not_delivered_note": "L'email non è arrivata alla casella PEC: la domanda è valida e la vedi qui. Controlla che la casella accetti anche la posta ordinaria.",
		"note": "Una nota per lo studente (facoltativa)",
		"note_hint": "{{count}} / {{max}}",
		"problem_done": "Problema segnalato. Lo studente riceve un'email con la causa.",
		"report": "Segnala un problema",
		"section": "Nella PEC del bando",
		"send_problem": "Segnala il problema",
		"sent_at": "Inviata il",
		"state": {
			"acknowledged": "Validità confermata",
			"awaiting": "In attesa di conferma",
			"problem": "Con un problema"
		},
		"subject": "Oggetto dell'email",
		"to": "Casella PEC del bando"
	},
	"search_placeholder": "Cerca per nome o protocollo",
	"state": {
		"submitted": "Inviata",
		"superseded": "Sostituita",
		"withdrawn": "Ritirata"
	},
	"timeline": {
		"acknowledged": "Validità confermata",
		"problem_reported": "Problema segnalato allo studente",
		"received_by_pec": "Ricevuta via PEC diretta",
		"submitted": "Inviata dallo studente",
		"superseded": "Sostituita da una nuova domanda",
		"transcription_corrected": "Correzione di trascrizione",
		"withdrawn": "Ritirata dallo studente"
	},
	"transmission": {
		"not_delivered": "Non consegnata"
	}
}
